import type { AppProps } from 'next/app';
import Head from 'next/head';

import useIsFirstRender from '@polyai/common/hooks/useIsFirstRender';
import type { ComponentWithChildren } from '@polyai/common/types/helpers';

import 'styles/styles.scss';

export const APP_NAME = 'PolyAI Studio';

const NullFirstRender: ComponentWithChildren = ({ children }) => {
  const isFirstRender = useIsFirstRender();

  if (isFirstRender) {
    return null;
  }

  return <>{children}</>;
};

const SafeHydrate: ComponentWithChildren = ({ children }) => {
  return (
    <div suppressHydrationWarning>
      {typeof window !== 'undefined' && (
        <NullFirstRender>{children}</NullFirstRender>
      )}
    </div>
  );
};

export default function PortalApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <title>{APP_NAME}</title>
        <meta
          content="width=device-width, initial-scale=1, maximum-scale=1"
          name="viewport"
        />
      </Head>
      <SafeHydrate>
        <Component {...pageProps} />
      </SafeHydrate>
    </>
  );
}
